import React, { useEffect, useRef } from 'react';
import { Bio } from '../../data/constants';

const Hero = ({ onOpenSummary }) => {
  const heroRef = useRef(null);

  useEffect(() => {
    const hero = heroRef.current;
    if (!hero) return;
    const run = () => { hero.classList.add('hero-animated'); };
    const timer = setTimeout(run, 150);

    // Parallax
    let ticking = false;
    const inner = hero.querySelector('.hero-l');
    const onScroll = () => {
      if (ticking || !inner) return;
      ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY;
        if (y < window.innerHeight) {
          inner.style.transform = `translateY(${y * 0.12}px)`;
        } else {
          inner.style.transform = '';
        }
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
    };
  }, []);

  const triggerNameWave = () => {
    const chars = heroRef.current?.querySelectorAll('.hero-char');
    if (!chars) return;
    chars.forEach((c, idx) => {
      setTimeout(() => {
        c.classList.remove('char-wave');
        void c.offsetWidth;
        c.classList.add('char-wave');
        setTimeout(() => c.classList.remove('char-wave'), 650);
      }, idx * 42);
    });
  };

  return (
    <section id="hero" data-chapter="00" data-chapter-name="Intro" ref={heroRef}>
      <div className="hero-l">
        <div className="hero-eyebrow">Hello, I'm</div>
        <h1 
          className="hero-name" 
          aria-label="Sarthak Joshi"
          onClick={triggerNameWave}
          title="Click to trigger animation"
        >
          <span className="hero-first-name" aria-hidden="true">
            {"Sarthak".split("").map((c, i) => (
              <span key={`fn-${i}`} className="hero-char" style={{ '--i': i }}>
                {c}
              </span>
            ))}
          </span>
          <em aria-hidden="true">
            {"Joshi".split("").map((c, i) => (
              <span key={`ln-${i}`} className="hero-char" style={{ '--i': i + 7 }}>
                {c}
              </span>
            ))}
          </em>
        </h1>
        <div className="hero-title">
          Full Stack Developer<br />
          Software Engineer · DevOps Engineer
        </div>
        <p className="hero-desc">{Bio.description}</p>
        <div className="hero-btns">
          <a className="btn-a" href="#projects">View Work</a>
          <a className="btn-b" href="#contact">Say hello →</a>
          {onOpenSummary && (
            <button
              type="button"
              className="btn-c btn-summary"
              onClick={onOpenSummary}
              title="Explore Interactive Life DAG Timeline"
            >
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="18" cy="5" r="3" />
                <circle cx="6" cy="12" r="3" />
                <circle cx="18" cy="19" r="3" />
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" />
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
              </svg>
              Life DAG
            </button>
          )}
          <a className="btn-c" href={Bio.resume} target="_blank" rel="noopener noreferrer">
            <svg width="11" height="11" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="1.6">
              <path d="M2.5 9.5 L9.5 2.5 M4 2.5 H9.5 V8" />
            </svg>
            Resume
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
